import { render, staticRenderFns } from "./authorisation.vue?vue&type=template&id=637483fc&"
import script from "./authorisation.vue?vue&type=script&lang=js&"
export * from "./authorisation.vue?vue&type=script&lang=js&"
import style0 from "./authorisation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports